import React from 'react';
import { SvgIcon } from '@mui/material';

export function FillYouTubeIcon(props) {
  return (
    <SvgIcon viewBox="0 0 42 42" {...props}>
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="42" height="42" rx="16" fill="#FFBC5B" />
        <path
          d="M33 19.5252C33 19.0101 32.9124 18.4091 32.9124 17.7222C32.8248 17.0354 32.7372 16.3485 32.6496 15.7475C32.4745 15.0606 32.2117 14.5455 31.6861 14.1162C31.2482 13.6869 30.635 13.4293 30.0219 13.3434C28.0073 13.0859 25.0292 13 21 13C16.9708 13 13.9051 13.0859 11.9781 13.3434C11.365 13.4293 10.7518 13.6869 10.3139 14.1162C9.87591 14.5455 9.52554 15.0606 9.35036 15.7475C9.17518 16.3485 9.0876 16.9495 9.0876 17.7222C9.00001 18.4091 9 19.0101 9 19.5252C9 20.0404 9 20.6414 9 21.5C9 22.3586 9 23.0455 9 23.4747C9 23.9899 9.0876 24.5909 9.0876 25.2778C9.17519 25.9646 9.26277 26.6515 9.35036 27.2525C9.52554 27.9394 9.78832 28.4545 10.3139 28.8838C10.7518 29.3131 11.365 29.5707 11.9781 29.6566C13.9927 29.9141 16.9708 30 21 30C25.0292 30 28.0949 29.9141 30.0219 29.6566C30.635 29.5707 31.2482 29.3131 31.6861 28.8838C32.1241 28.4545 32.4745 27.9394 32.6496 27.2525C32.8248 26.6515 32.9124 26.0505 32.9124 25.2778C33 24.5909 33 23.9899 33 23.4747C33 22.9596 33 22.3586 33 21.5C33 20.6414 33 19.9545 33 19.5252ZM25.6423 22.1869L19 26C19 26 18.4485 26.3939 18.2733 26.3939C18.1657 26.3939 18.0299 26.4798 17.8548 26.3939C17.592 26.2222 17.5 25.8434 17.5 25.5L17.5797 17.7222C17.5797 17.3788 17.5839 16.6061 17.8467 16.4343C18.1095 16.2626 18.4599 16.2626 18.7226 16.4343L25.6423 20.6414C25.9051 20.8131 26.0803 21.0707 26.0803 21.3283C26.0803 21.5859 25.9051 22.0151 25.6423 22.1869Z"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
